export const PricingUris = [
    '/pricing',
    '/en/pricing',
    '/fr/tarifs',
    '/de/preise',
    '/pt/preco',
    '/ja/料金',
    '/it/tariffe',
    '/es/precios',
    '/ja/%E6%96%99%E9%87%91',
];
